import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzK9Drsl } from './pages'

type TIdToPageMapWoofzK9Drsl = Record<PageIdWoofzK9Drsl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_K9_DRSL: TIdToPageMapWoofzK9Drsl = {
  [PageIdWoofzK9Drsl.DOG_AGE_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogAge').then(
        (m) => ({
          default: m.DogAge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogAge'),
  },
  [PageIdWoofzK9Drsl.DOG_SEX_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/SexQuestion'),
  },
  [PageIdWoofzK9Drsl.DOG_BREED_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzK9Drsl.DOG_BREED_ID_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ).then((m) => ({
        default: m.BreedPhotoScreenK9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ),
  },
  [PageIdWoofzK9Drsl.URGE_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePage'),
  },
  [PageIdWoofzK9Drsl.CHALLENGES_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/GoalsQuestionK9'
      ).then((m) => ({
        default: m.GoalsQuestionK9,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/GoalsQuestionK9'),
  },
  [PageIdWoofzK9Drsl.URGE_1_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/urge/Urge1Page'),
  },
  [PageIdWoofzK9Drsl.LEASH_PULLING_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/LeashPulling').then(
        (m) => ({
          default: m.LeashPulling,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/LeashPulling'),
  },
  [PageIdWoofzK9Drsl.URGE_LEASH_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeLeashPage').then(
        (m) => ({
          default: m.UrgeLeashPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeLeashPage'),
  },
  [PageIdWoofzK9Drsl.DURING_WALK_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/DuringWalkQuestion'
      ).then((m) => ({
        default: m.DuringWalkQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DuringWalkQuestion'),
  },
  [PageIdWoofzK9Drsl.URGE_NOT_ALONE_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeNotAlone').then(
        (m) => ({
          default: m.UrgeNotAlonePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeNotAlone'),
  },
  [PageIdWoofzK9Drsl.AGRESSIVE_BEHAVIOR_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/AgressiveBehavior'
      ).then((m) => ({
        default: m.AgressiveBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzK9Drsl.TRIGGERS_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/TriggersQuestion'
      ).then((m) => ({
        default: m.TriggersQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzK9Drsl.URGE_2_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzK9Drsl.BEHAVIOR_ISSUES_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/BehaviorIssues').then(
        (m) => ({
          default: m.BehaviorIssues,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzK9Drsl.DOG_ACT_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzK9Drsl.DOG_OFF_AT_HOME_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzK9Drsl.REWARDS_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/RewardsQuestion'
      ).then((m) => ({
        default: m.RewardsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/RewardsQuestion'),
  },
  [PageIdWoofzK9Drsl.IGNORE_COMMANDS_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/DogIgnoreQuestion'
      ).then((m) => ({
        default: m.DogIgnoreQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/DogIgnoreQuestion'),
  },
  [PageIdWoofzK9Drsl.COMMANDS_61_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/Commands61Question'
      ).then((m) => ({
        default: m.Commands61Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/Commands61Question'),
  },
  [PageIdWoofzK9Drsl.COMMANDS_62_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/Commands62Question'
      ).then((m) => ({
        default: m.Commands62Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/Commands62Question'),
  },
  [PageIdWoofzK9Drsl.COMMANDS_63_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/questions/Commands63Question'
      ).then((m) => ({
        default: m.Commands63Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/Commands63Question'),
  },
  [PageIdWoofzK9Drsl.URGE_3_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeProgram').then(
        (m) => ({
          default: m.UrgeProgram,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzK9Drsl.PREPARE_SCREEN_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzK9Drsl.DOG_PROFILE_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzK9Drsl.URGE_REVIEWED_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeReviewed').then(
        (m) => ({
          default: m.UrgeReviewedPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/urge/UrgeReviewed'),
  },
  [PageIdWoofzK9Drsl.PREPARE_FLOW_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzK9Drsl.EMAIL_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/email/Email'),
  },
  [PageIdWoofzK9Drsl.NEWSLETTER_URGE_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzK9Drsl.WELCOME_TO_WOOFZ_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/WelcomeToWoofz').then(
        (m) => ({
          default: m.WelcomeToWoofz,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/questions/WelcomeToWoofz'),
  },
  [PageIdWoofzK9Drsl.SUBSCRIPTIONS_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzK9Drsl.CHAT_UPSELL_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzK9Drsl.UPSELL_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_drsl/pages/upsell/Upsell'),
  },
  [PageIdWoofzK9Drsl.UPSELL_FEEDING_GUIDE_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/upsell/FeedingGuideUpsell'
      ).then((m) => ({
        default: m.FeedingGuideUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzK9Drsl.UPSELL_EMOTIONAL_SUPPORT_K9_DRSL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_drsl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzK9Drsl.DOWNLOAD_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzK9Drsl.ACCOUNT_K9_DRSL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_drsl/modules/account/AccountK9Drsl').then(
        (m) => ({
          default: m.AccountK9Drsl,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_drsl/modules/account/AccountK9Drsl'),
  },
}
